// extracted by mini-css-extract-plugin
export default {"wizard_option":"WizardOption_wizard_option__dC5uN","wizard_option__button":"WizardOption_wizard_option__button__mBSaA","spin":"WizardOption_spin__9BVFH"};